import {AxiosError} from 'axios';
import {GET_INTENDED_RESIDENTIAL_AREA_URL} from '../../constants/apiUrls';
import {GET_INTENDED_RESIDENTIAL_AREA_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {LookupListApiItem} from '../../api/user/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: LookupListApiItem[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetIntendedResidentialArea = ({
                                                onSuccess,
                                                onError,
                                                enabled = true,
                                              }: Input = {}) => {
  const getIntendedResidentialArea = async () => {
    const res = await axiosClient.get<LookupListApiItem[]>(GET_INTENDED_RESIDENTIAL_AREA_URL);
    return res.data;
  };

  return useCustomQuery(GET_INTENDED_RESIDENTIAL_AREA_QUERY_KEY, getIntendedResidentialArea, {
    onSuccess,
    onError,
    enabled,
    staleTime: Infinity,
  });
};
